// extracted by mini-css-extract-plugin
export default {"titulo":"Faq_titulo__woqjV","askedQuestion":"Faq_askedQuestion__se8Mx","accordion":"Faq_accordion__L9-ND"};